import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';

import './styles.css';
import constants from './constants.jsx'
// import ReferGraphic from '../img/refer-graphic.svg';

const ReferPage = props => {
  const getSection = () => {
    const { roleType } = props.role;
    if (roleType === 'FACULTY' || roleType === 'STAFF') {
      return (
        <div>
          <p>{constants.faculty1}</p>
          <p>{constants.faculty2}</p>
        </div>
      );
    } else if (roleType === 'STUDENT') {
      return (
        <div>
          <p>{constants.student1}</p>
          <p>{constants.student2}</p>
        </div>
      );
    }

    return (
      <div>
        <p><strong>Faculty and staff, this section is specific to your role on campus:</strong></p>
        <p>{constants.faculty1}</p>
        <p>{constants.faculty2}</p>


        <p><strong>Students in leadership and staff positions, this section is specific to your role on campus:</strong></p>
        <p>{constants.student1}</p>
        <p>{constants.student2}</p>
      </div>
    );
  }

  return (
    <EducationModuleLayout
      progressStage={7}
      childTitle="Refer"
      progressType="refer"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <h2 className="txt-blue no-bold no-margin">Know your Reporting Structure</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              {getSection()}
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-blue previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer to={url.REFER_H} className="btn btn-blue next">
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

ReferPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const ReferG = connect.role(ReferPage);

export default ReferG;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferG/index.jsx